(function () {
  'use strict';
  function reveal() {
    var els = document.querySelectorAll('[data-vk-reveal]:not(.vk-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vk-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vk-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  function faq() {
    document.querySelectorAll('.vk-faq-item').forEach(function (item) {
      if (item.dataset.vkBound) return;
      item.dataset.vkBound = '1';
      item.addEventListener('click', function () { item.classList.toggle('vk-open'); });
    });
  }
  function menu() {
    var drawer = document.querySelector('.vk-drawer-menu');
    if (!drawer) return;
    document.querySelectorAll('[data-vk-menu-toggle]').forEach(function (b) {
      if (b.dataset.vkBound) return;
      b.dataset.vkBound = '1';
      b.addEventListener('click', function () { drawer.classList.toggle('vk-open'); });
    });
  }
  function gallery() {
    var root = document.querySelector('[data-vk-gallery]');
    if (!root || root.dataset.vkBound) return;
    root.dataset.vkBound = '1';
    var main = root.querySelector('[data-vk-gallery-main]');
    root.querySelectorAll('[data-vk-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) main.src = btn.dataset.vkThumb;
        root.querySelectorAll('[data-vk-thumb]').forEach(function (b) { b.classList.remove('vk-active'); });
        btn.classList.add('vk-active');
      });
    });
  }
  function qty() {
    document.querySelectorAll('[data-vk-qty]').forEach(function (box) {
      if (box.dataset.vkBound) return;
      box.dataset.vkBound = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var v = parseInt(input.value, 10) || 1;
          v += (b.dataset.vkStep === '+' ? 1 : -1);
          input.value = Math.max(1, v);
        });
      });
    });
  }
  function init() { document.body.classList.add('vk'); reveal(); faq(); menu(); gallery(); qty(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();